import socket from './socket';

/* Actions */

const getAlerts = (headers) => socket.get('/alerts?page=0&limit=100', undefined, headers);

const getAlertsOccur = (headers) =>
  socket.get('/alerts-occur?page=0&limit=100', undefined, headers);

const getAlertsRes = (headers) => socket.get('/alerts-res?page=0&limit=100', undefined, headers);

const getAlertData = (deviceId, data, headers) =>
  socket.post(`/alerts/alerts-data/${deviceId}`, data, headers).then((body) => ({
    ...body,
    items: body.items,
  }));

export default {
  getAlerts,
  getAlertsOccur,
  getAlertsRes,
  getAlertData,
};
